/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-events',
    'pip-model',
	'pip-common.text-aisle-bay',
    'window'
],
function pipAisleBay(
    $,
    Mustache,
    pipEvents,
    pip,
	pipTextAisleBay,
    window
){

    function formatAisleBayResponse(aisleBayResponse) {
        var aisleBayData = $.extend({}, aisleBayResponse);

        if(aisleBayData && aisleBayData.locationDesc && aisleBayData.locationDesc.toLowerCase() === 'showroom') {
            return "Appliance Showroom";
        }

        aisleBayData.aisleRaw = aisleBayData.aisle;

        if (aisleBayData) {
            if (aisleBayData.aisle) {
                aisleBayData.aisle = 'Aisle ' + aisleBayData.aisle;
            }
            if (aisleBayData.locationDesc) {
                aisleBayData.aisle = aisleBayData.locationDesc;
            }
            if (aisleBayData.aisle.toLowerCase().indexOf("end cap") !== -1) {
                aisleBayData.aisle = "End Cap" + (aisleBayData.aisleRaw ? aisleBayData.aisleRaw.replace('E', ' ') : '');
            }
            if (aisleBayData.bay && aisleBayData.aisle) {
                aisleBayData.bay = ', Bay ' + aisleBayData.bay;
            } else {
                aisleBayData.bay = '';
            }
        }

        return (aisleBayData.aisle ? aisleBayData.aisle : '') + (aisleBayData.bay ? aisleBayData.bay : '');
    }

    function shouldCallAisleBayService() {
        var isStoreSelected = !!(pip.customer.localStore && pip.customer.localStore.storenumber);
        var isNotOnlineProduct = pip.products.primary.data.availabilityType !== 'Online';
        var isMajorAppliance = pip.products.primary.data.itemType === 'MAJOR_APPLIANCE';
        var isAvailable = isNotOnlineProduct || isMajorAppliance;

        if(!isAvailable) return false;

        if (pip.features.aisleAndBayReqInStockCheckFeatureEnabled) {
            var isInStockAtStore = pip.inventory && pip.inventory.store && pip.inventory.store.isInStock;
            var isAssortedToLocalStore = pip.fulfillment && pip.fulfillment.isAssortedToLocalStore;
            var isInStock = (isInStockAtStore && isAssortedToLocalStore) || pip.isAnchorStore === false;

            return isStoreSelected && isAvailable && isInStock;
        }

        return isStoreSelected && isAvailable;
    }


    function callAisleBayService() {
        if(!shouldCallAisleBayService()) return $.Deferred().reject();

        var storeSku = pip.products.primary.data.info.storeSkuNumber;
        var storeId = pip.customer.localStore.storenumber;

        if (!pip.isAnchorStore && pip.nearbyStore && pip.nearbyStore.storeId) {
            storeId = pip.nearbyStore.storeId;
        }

        var endpoint = "/edge-service/aislebay?storeSkuid=" + storeSku + "&storeid=" + storeId + "&type=json";

        return $.ajax({
            type: "GET",
            url: endpoint,
            cache: false,
            dataType: "json"
        });
    }

    var aisleBayInstance;
    function getFormattedAisleBay(cameFromSsku) {
        if(aisleBayInstance && !cameFromSsku) return aisleBayInstance;

        aisleBayInstance = $.Deferred();
        callAisleBayService().done(function (data) {
            if(!data || !data.storeSkus || !data.storeSkus[0]) {
                return aisleBayInstance.reject();
            }

            var formattedResponseString = formatAisleBayResponse(data.storeSkus[0].aisleBayInfo);
            pip.products.primary.data.aisleBay = data.storeSkus[0].aisleBayInfo;
            pip.products.primary.data.aisleBay.formatted = formattedResponseString;
            return aisleBayInstance.resolve(formattedResponseString);
        });
        return aisleBayInstance;
    }

	return {
        getFormattedAisleBay: getFormattedAisleBay,
        shouldDisplayAisleBayForAppliances: function () {
            var deferred = $.Deferred();
            callAisleBayService().done(function (data) {

                if(!data
                    || !data.storeSkus
                    || !data.storeSkus[0]
                    || !data.storeSkus[0].aisleBayInfo) {
                        return deferred.resolve(false);
                }

                if(data
                    && data.storeSkus
                    && data.storeSkus[0]
                    && data.storeSkus[0].aisleBayInfo
                    && data.storeSkus[0].aisleBayInfo.locationDesc
                    && data.storeSkus[0].aisleBayInfo.locationDesc.toLowerCase() === 'showroom') {
                        return deferred.resolve("Appliance Showroom");
                } else {
                        return deferred.resolve(formatAisleBayResponse(data.storeSkus[0].aisleBayInfo));
                }
            });
            return deferred;
        },
        shouldCallAisleBayService: shouldCallAisleBayService,
        formatAisleBayResponse: formatAisleBayResponse
	}
});

}.call(window));